export default "__VITE_ASSET__C8Jua8Zg__"